"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toYearWeek = exports.searchWeeksInYear = exports.getWeeksFromYear = exports.findWeekInAvailableDates = void 0;
var findWeekInAvailableDates = function (avail, findWeek) {
    return avail.Weeks.find(function (e) { return e.Week === findWeek.Week && e.Year === findWeek.Year; });
};
exports.findWeekInAvailableDates = findWeekInAvailableDates;
var getWeeksFromYear = function (avail, year) {
    return avail.Weeks.filter(function (e) { return e.Year === year; });
};
exports.getWeeksFromYear = getWeeksFromYear;
var searchWeeksInYear = function (avail, year, search) {
    var find = new RegExp(search, "i");
    var weeks = exports.getWeeksFromYear(avail, year);
    return weeks.filter(function (item) { return item.Caption.match(find); });
};
exports.searchWeeksInYear = searchWeeksInYear;
var toYearWeek = function (year, week) { return Number("" + year + week.toString().padStart(2, "0")); };
exports.toYearWeek = toYearWeek;
